import About from '../../../templates/views/About';

export default {
  path: 'about',
  component: About,
  name: 'About',
  meta: {
    title: t => t('screens.aboutScreen', 'app_mobile'),
    loggedInOnly: true
  },
};

